import {
  EuiButtonIcon,
  EuiLink,
  EuiPopover,
  EuiText,
} from "@inscopix/ideas-eui";
import { DataTableColumnGroupDefinition } from "../store/DataTableProvider.types";
import { useState } from "react";
import { useDataTableContext } from "../store/DataTableProvider";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";

interface ColumnGroupHeaderBaseJoinLinkProps {
  groupDefinition: Extract<DataTableColumnGroupDefinition, { kind: "join" }>;
}

export const ColumnGroupHeaderBaseJoinLink = ({
  groupDefinition,
}: ColumnGroupHeaderBaseJoinLinkProps) => {
  const projectKey = useDataTableContext((s) => s.project.key);

  const tenantKey = useTenantContext((s) => s.currentTenant.key);

  const navigateToTable = useRouteMapContext(
    (s) => (tableKey: string) =>
      s.routeMap["PROJECT_TABLE"]

        .dynamicPath({ projectKey, tableKey, tenantKey })

        .navigateTo(),
  );
  const sourceTable = useDataTableContext((s) => {
    return s.tables.find(({ id }) => id === groupDefinition.table.id);
  });
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  // Display nothing if source table is unavailable
  if (sourceTable === undefined) {
    return null;
  }

  return (
    <EuiPopover
      button={
        <EuiButtonIcon
          aria-label="Join column source"
          color="primary"
          size="xs"
          iconSize="s"
          iconType="link"
          onClick={() => setIsPopoverOpen((isOpen) => !isOpen)}
        />
      }
      isOpen={isPopoverOpen}
      closePopover={() => setIsPopoverOpen(false)}
      anchorPosition="downCenter"
      ownFocus={false}
    >
      <div style={{ width: "300px" }}>
        <EuiText size="s">
          <p>
            Cell values in these columns cannot be manually edited. Their values
            are derived from the values set in the{" "}
            <EuiLink onClick={() => navigateToTable(sourceTable.key)}>
              {sourceTable.name}
            </EuiLink>{" "}
            table.
          </p>
        </EuiText>
      </div>
    </EuiPopover>
  );
};
